import { createContext, useContext, useEffect, useState } from 'react'
import { RequestService } from '../services/RequestService'

const SleepQuantityContext = createContext()

const today = new Date()
const currentYear = today.getFullYear()
const currentMonth = today.getMonth()
const startDate = new Date(currentYear, currentMonth, 1)

export const GRANULARITY = {
  TITLE: 'title',
  SHIFT: 'shift',
  TEAM: 'team',
}

export const SleepQuantityProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingFilters, setLoadingFilters] = useState(true)
  const [dateRange, setDateRange] = useState([startDate, new Date()])
  const [filterOptions, setFilterOptions] = useState(null)
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [granularity, setGranularity] = useState(GRANULARITY.TITLE)
  const [graphMessage, setGraphMessage] = useState(null)

  const onSelectFilter = value => {
    setSelectedUser(null)
    setInputValue('')
    setSelectedFilterOptions(value)
  }

  const onSelectUser = value => {
    setSelectedUser(value)
    setInputValue(value.name)
    setSelectedFilterOptions([])
  }

  const onChangeGranularity = event => {
    setGranularity(event.target.value)
  }

  const fetchData = async () => {
    if (!loading) setLoading(true)

    try {
      const { data } = await RequestService.getSleepQuantity({
        date: dateRange,
        selectedFilterOptions,
        selectedUserId: selectedUser?.id,
        granularity,
      })

      setData(data.data)
      setGraphMessage(data.graphMessage)
    } catch (error) {
      console.error('Error on data fetch', error)
    }

    setLoading(false)
  }

  const getPossibleFilters = async () => {
    if (!loadingFilters) setLoadingFilters(true)

    try {
      const { data } = await RequestService.getSleepQuantityFilters()

      setFilterOptions(data)
    } catch (error) {
      console.error('Error on data fetch filters', error)
    }

    setLoadingFilters(false)
  }

  useEffect(() => {
    fetchData()
  }, [dateRange, selectedFilterOptions, selectedUser?.id, granularity])

  useEffect(() => {
    getPossibleFilters()
  }, [])

  return (
    <SleepQuantityContext.Provider
      value={{
        data,
        loading,
        dateRange,
        onDateRangeChange: setDateRange,
        loadingFilters,
        filterOptions,
        onSelectFilter,
        selectedFilterOptions,
        selectedUser,
        onSelectUser,
        inputValue,
        onInputValueChange: setInputValue,
        granularity,
        onChangeGranularity,
        graphMessage,
      }}
    >
      {children}
    </SleepQuantityContext.Provider>
  )
}

export const useSleepQuantity = () => {
  return useContext(SleepQuantityContext)
}
